import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { ModalButtonArea, BigButton } from '.';
import { icons } from '../assets';
import { DELETE_ICON, ARCHIVE_ICON } from '../constants/assetConstants';
import { apiErrorHandler } from '../helpers/axiosHelper';
import pluralize from 'pluralize';
import { CURRENT_USER } from '../constants/projectConstants';
import { getCurrentlyOpenProjectId, getLocalStorage } from '../helpers/jsHelper';
import { errorToast, multiInfoToast } from '../helpers/toastHelper';
import { getMultipleResponseList } from '../helpers/urlHelper';
import { useCheckCuratorActive } from "../hooks/useCuratorActive";

const { BinIcon, ArchiveIcon } = icons;

// This one will be used by delete, archive and remove forever functionality
export default function DeactivatePopup(props) {
  // console.log("actionWord DeactivatePopup: ", props)
  const user = getLocalStorage(CURRENT_USER, true);
  const { isCuratorActive, getCuratorList } = useCheckCuratorActive();
  const isActiveCurator = async () => {
    const curatorActive = await isCuratorActive();
    return curatorActive;
  };

  const { selectedList, id, isPlural, actionWord = 'delete', user_details } = props;
  // console.log("selectedList: ", selectedList)
  const [modalOpen, setModalOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const articleWord = isPlural ? 'these' : 'this';
  let item = props.item;
  if (item.includes('-')) {
    item = _.chain(item).split('-').join(' & ').value();
  }
  const labelText = item === 'uploads' ? 'custom maps' : item;
  // const labelIsPlural = item === 'uploads' ? false : isPlural;
  const phrase = isPlural
    ? `${articleWord} ${pluralize.plural(labelText)}`
    : `${articleWord} ${pluralize.singular(labelText)}`;
  const deleteTitle =
    selectedList?.length === 1
      ? `Do you want to delete "${selectedList?.[0]?.name}"`
      : `Are you sure you want to ${actionWord} ${phrase}?`;
  const subtitle =
    selectedList?.length === 1
      ? 'Your item can be restored from the trash area.'
      : 'Your items can be restored from the Trash area.';
  const deleteButtonPrompt = _.capitalize(actionWord); //`Yes, please ${actionWord} ${phrase}`;
  let errorMessage = props?.errorMessage || `There was an error trying to ${actionWord} ${phrase}`;
  let successMessage = `${_.capitalize(phrase)} have been successfully ${actionWord}d`;

  let buttonIcon = BinIcon;
  let iconSrc = props.iconSrc || DELETE_ICON;
  if (actionWord === 'archive') {
    buttonIcon = ArchiveIcon;
    iconSrc = ARCHIVE_ICON;
  }

  useEffect(() => {
    return () => {
      setProcessing(false);
    };
  }, []);

  const processAction = async () => {
    let data = isPlural ? selectedList : [{ id: id }];
    const openCurator = await isActiveCurator();
    let isActive = null;
    data?.map((info) => {
      if (!isActive) {
        isActive =
          openCurator &&
          getCurrentlyOpenProjectId(
            getCuratorList()?.map((url) => url?.uniqueUrl),
            info?.id
          );
      }
    });
    if (isActive) {
      setProcessing(false);
      setModalOpen(false);
      errorToast('Please close or save this project before deleting.');
      return;
    }
    if (_.isFunction(props.onConfirm)) {
      // this one is used for removing items from collection, since the "delete" from the collection
      // is a more complicated payload structure
      props.onConfirm(setProcessing, data);
    }
    if (_.isFunction(props.deleteAction)) {
      setProcessing(true);
      let payload;
      payload = new FormData();

      if (isPlural) {
        _.map(selectedList, (card) => {
          payload.append('id', card.id);
        });
      } else {
        payload.append('id', id);
      }
      // TODO
      // disabling this for now until we complete the permissions area
      // since some delete apis will only be available to
      // live furnish staff only

      // setProcessing(false);
      const msg = selectedList?.length > 1 ? 'files are' : 'file is';
      const successMsg = `The ${msg} successfully ${actionWord}d`;

      props
        .deleteAction(payload, null, errorMessage)
        .then((res) => {
          if (res && res.status) {
            setModalOpen(false);
            multiInfoToast(
              getMultipleResponseList(res?.data, selectedList, 'Deleted'),
              `Delete Details`
            );
            if (_.isFunction(props.onSuccess)) {
              props.onSuccess(id);
            }
          }
        })
        .catch((error) => {
          console.log('error:', error);
          multiInfoToast(
            getMultipleResponseList(error?.data, selectedList, 'Deleted'),
            `Delete Details`
          );
          props.onSuccess();
        })
        .finally(() => {
          setProcessing(false);
          setModalOpen(false);
        });
    } else if (_.isFunction(props?.deleteSharedModel)) {
      const deleteUserId = user_details?.find(
        (item) => item?.shared_to_detail?.user?.id === user?.user?.id
      );
      if (deleteUserId !== undefined) {
        // console.log('deleted', deleteUserId);
        props
          .deleteSharedModel(deleteUserId?.id, successMessage, errorMessage)
          .then((res) => {
            if (res && res.status) {
              setModalOpen(false);
              if (_.isFunction(props.onSuccess)) {
                props.onSuccess(id);
              }
            }
          })
          .catch(apiErrorHandler)
          .finally(() => setProcessing(false));
      } else {
        errorToast('Action is not allowed');
      }
    }
  };

  return (
    <ModalButtonArea
      className="smallPopup"
      iconOnly={props.iconOnly}
      button={props.button}
      bigButton={props.bigButton}
      bigBtnClass={props?.bigBtnClass}
      hideButtonText={props.hideButtonText}
      miniButton={props.miniButton}
      footerButton={props.footerButton}
      icon={props.icon}
      variant={props.disabled ? 'outline-secondary' : 'outline-dark'}
      buttonIcon={buttonIcon}
      buttonTitle={_.startCase(actionWord)}
      disabled={props.disabled || false}
      title={props.title || deleteTitle}
      dialogTitle={props.dialogTitle}
      subtitle={props.subtitle || subtitle}
      size="md"
      setShowModal={setModalOpen}
      showModal={modalOpen}
      includeCancelButton={true}
      cancelBtnClassname="lf-btn-2"
      promptButton={
        <BigButton
          onClick={processAction}
          className={`${props?.isCurator ? 'lf-btn-3' : 'btn-warning'} keep-text`}
          disabled={processing}
          isLoading={processing}
          buttonTitle={deleteButtonPrompt}
        />
      }
      iconSrc={iconSrc}
      buttonLabel={props.buttonLabel}
    />
  );
}
